import classNames from "classnames";
import { forwardRef, useMemo } from "react";

const TextAreaField = forwardRef((props, ref) => {
  const { name, label, disabled, required, error, ...rest } = props;

  const labelMemo = useMemo(() => {
    return `${label}${required ? " *" : ""}`;
  }, [label, required]);

  return (
    <div className="text-area-field__container">
      <div
        className={classNames("text-area-field__content", {
          disabled: disabled,
          invalid: error,
        })}
      >
        <label
          htmlFor={name}
          className={classNames("text-area-field__label", "smaller")}
        >
          {labelMemo}
        </label>
        <textarea
          {...rest}
          ref={ref}
          className={classNames("text-area-field__input", {
            disabled: disabled,
          })}
        />
      </div>
      <p
        className={classNames("text-area-field__error", {
          show: error,
        })}
      >
        {error}
      </p>
    </div>
  );
});

export default TextAreaField;
